/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Aditya Shrivastava",
  title: "Hi, I'm Aditya",
  subTitle: emoji(
    "A passionate Software Developer, certified in AWS Solutions Architect - Associate, having experience of building Web & Mobile applications with Java / Python / Kotlin and Programming using various cool libraries and frameworks."
  ),
  resumeLink: require("./assets/aditya_shrivastava.pdf"), // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/aditya-shri",
  linkedin: "https://www.linkedin.com/in/aditya-shri/",
  gmail: "aditya.shrivastava.716@gmail.com",
  //gitlab: "https://gitlab.com/saadpasta",
  //facebook: "https://www.facebook.com/saad.pasta7",
  //medium: "https://medium.com/@saadpasta",
  stackoverflow: "https://stackoverflow.com/users/14307267/aditya-shrivastava",
  instagram: "https://instagram.com/aditya.shrivastav",
  // Instagram and Twitter are also supported in the links!
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji("⚡ Develop interactive web and backend applications using various frameworks from Java, Python etc"),
    emoji("⚡ Automating builds and deployments using Docker and Kubernetes"),
    emoji("⚡ Multi-functional Android Application development using Java"),
    emoji("⚡ Scripting and API development using Python"),
    emoji("⚡ Integration and use of various cloud services such as Heroku, AWS etc")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
  {
    skillName: "Java",
    fontAwesomeClassname: "fab fa-java"
  },
  {
    skillName: "Python",
    fontAwesomeClassname: "fab fa-python"
  },
  {
    skillName: "Spring",
    fontAwesomeClassname: "fa-solid fa-cloud"
  },
  {
    skillName: "Jersey",
    fontAwesomeClassname: "fa-solid fa-shirt"
  },
  {
    skillName: "Kubernetes",
    fontAwesomeClassname: "fa-brands fa-docker"
  },
  {
    skillName: "Docker",
    fontAwesomeClassname: "fa-brands fa-docker"
  },
  {
    skillName: "AWS",
    fontAwesomeClassname: "fab fa-aws"
  },
  {
    skillName: "Linux",
    fontAwesomeClassname: "fa-brands fa-linux"
  },
  {
    skillName: "Jax-RS",
    fontAwesomeClassname: "fas fa-server"
  },
  {
    skillName: "SQL-Database",
    fontAwesomeClassname: "fas fa-database"
  },
  {
    skillName: "Cloudflare",
    fontAwesomeClassname: "fas fa-cloud"
  },
  {
    skillName: "Git",
    fontAwesomeClassname: "fa-brands fa-git"
  },
  {
    skillName: "Html-5",
    fontAwesomeClassname: "fab fa-html5"
  },
  {
    skillName: "CSS3",
    fontAwesomeClassname: "fab fa-css3-alt"
  }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "University Institute of Technology, RGPV",
      logo: require("./assets/images/rgpv.png"),
      subHeader: "Bachelor of Technology in Computer Science",
      duration: "June 2018 - May 2022",
      desc: "Took courses about Software Engineering, Web Security, Operating Systems, Programming languages etc",
      descBullets: ["CGPA : 8.15"]
    },
    {
      schoolName: "Christ Senior Secondary School",
      logo: require("./assets/images/Christ.png"),
      subHeader: "Studied Physics, Chemistry and Maths along with Computer Basics & Programming",
      duration: "June 2016 - April 2017",
      desc: "",
      descBullets: [
        "XII Percentage : 83%",
        "X CGPA : 9.6"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend",
      progressPercentage: "80%"
    },
    {
      Stack: "Programming & Scripting",
      progressPercentage: "70%"
    },
    {
      Stack: "Automation/Devops", //Insert stack or technology you have experience in
      progressPercentage: "65%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Android Development", //Insert stack or technology you have experience in
      progressPercentage: "65%" //Insert relative proficiency in percentage
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const personalProjects = {
  display: true, //Set it to true to show personalProjects Section
  experience: [
    {
      role: "Guide",
      company: "",
      link: "https://github.com/aditya-shri/Guide",
      companylogo: require("./assets/images/Guidelogo.png"),
      date: "August 2020 – September 2020",
      desc: "Guide is an Android application that uses AI models to help disabled people in easy navigation and communication. Its a resume android project to showcase Android development capabilities",
      descBullets: [
        "Build using Android SDK in Java and AI models were trained using Python",
        "Uses AI Models trained on huge database which provides accurate result"]
    },
    {
      role: "Curexia",
      company: "",
      link: "https://github.com/curexia",
      companylogo: require("./assets/images/curexia.jpg"),
      date: "May 2021 – June 2021",
      desc: "Curexia is the complete health solution. It helps user to search all health related queries at one place",
      descBullets: [
        "Uses Html/CSS and Ajax on Frontend and JSP/Servlet with PostgreSQL on Backend",
        "Lets you search medicine and get their details", 
        "Lets you get details about disease",
        "Provides a symptoms checker",
        "It provides a platform to easily maintain patients’ medical history."
      ]
    },
    {
      role: "Debug-IT",
      company: "",
      link: "https://github.com/aditya-shri/DebugIt",
      companylogo: require("./assets/images/Debugitlogo.png"),
      date: "Nov 2020 – Dec 2020",
      desc: "Debug-it is a powerful bug tracker that helps you to view issues filtered by severity. It improves the productivity by tracking bugs and their status. It is an online tool that provides facilities like:",
      descBullets: [
        "Build using Java, JSP/Servlet with MySQL for the backend and HTML/CSS on Frontend",
        "Easily Deployable on cloud services like Heroku etc",
        "Allows you to create projects, add bugs and multiple users on a single platform",
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const workExperience = {
  title: "Work Experience",
  subtitle: "SOME COMPANIES AND STARTUPS WHERE I WORKED TO DEVELOP THEIR TECH",
  projects: [
    {
      image: require("./assets/images/google.png"),
      projectName: "Google",
      projectDesc: "Building Software Solutions For Google and Google Cloud",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://google.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/gupshup.png"),
      projectName: "Gupshup",
      projectDesc: "Conversational tools for customer engagement",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://gupshup.io/"
        }
        //  you can add extra buttons here.
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Certifications"),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "AWS Certified Solution Architect - Associate",
      subtitle:
        "Passed the AWS Certified Solution Architect - Associate examination.",
      image: require("./assets/images/aws.png"),
      footerLink: [
        {
          name: "Certificate",
          url: "https://www.credly.com/badges/802024ce-f4a5-4bd3-95d2-be8fa47d983a"
        }
      ]
    },
    {
      title: "Programming BootCamp",
      subtitle:
        "Completed Java and Python Programming courses from Udemy covering all topics from basic to complete development.",
      image: require("./assets/images/udemy.webp"),
      footerLink: [
        {
          name: "Java Certificate",
          url: "https://www.udemy.com/certificate/UC-f4853e6c-7a17-4d13-b95b-120b2f35ad74/"
        },
        {
          name: "Python Certificate",
          url: "https://www.udemy.com/certificate/UC-1d5ce771-75ff-4b25-a1d2-e8e8e5f3b1b5/"
        }
      ]
    },
    {
      title: "Machine Learning Workshop",
      subtitle: "Completed introductory workshop on Machine Learning and its working organised by Nit Bhopal in assocation with IIT Bombay.",
      image: require("./assets/images/ML.png"),
      footerLink: []
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const githubDetails = {
  userName: "aditya-shri", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "",
  email_address: "aditya.shrivastava.716@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  personalProjects,
  openSource,
  workExperience,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection,
  githubDetails
};
